<template lang="pug">
    div
        div.sideMenuWrapper(:class="{'open': open}")
            div.sideMenu
                div
                    div.title Filter
                    slot

                div
                    separator-component

                    button-component.submit(
                        color="primary"
                        :action="toggleOpen"
                    ) {{ $t('defaultButtons.submit') }}

        div.buttonWrapper
            v-btn(
                fab
                small
                @click="toggleOpen"
            )
                v-icon(v-if="open") close
                v-icon(v-else) filter_list

</template>

<script>
    import Button from '../Button';
    import Separator from '../Separator';

    export default {
        components: {
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        data() {
            return {
                open: false
            };
        },
        methods: {
            toggleOpen() {
                this.open = !this.open;
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl";

    .sideMenuWrapper
        position: fixed
        left: -185px
        top: 55px
        width: 185px
        height: calc(100% - 85px)
        padding: 5px
        background-color: #FFFFFF
        transition: left 0.3s

        &.open
            left: 0

    .sideMenu
        display: flex
        flex-direction: column
        justify-content: space-between
        height: 100%

    .title
        font-size: 20px
        font-weight: 700
        color: $theme.black

    .submit
        width: 100%
        margin: 0

    .buttonWrapper
        position: fixed
        right: 0
        bottom: 40px
</style>
